import React, { useState, useEffect } from "react";

import Header from "./Header.jsx";
import ContractSummary from "./ContractSummary.jsx";
import BusinessSizeBreakdown from "./BusinessSizeBreakdown.jsx";

import { getGroupCounts, getBusinessSizeCounts } from "../../../api/contractHolders.js";

import { getContractCounts } from "../../../util/businessBreakdown.js";

/**
 * @typedef {import("../../../jsdoc/BusinessSizeCount.js").BusinessSizeCount} BusinessSizeCount
 * @typedef {import("../../../jsdoc/GroupCount.js").GroupCount} GroupCount
 * @typedef {import("../../../jsdoc/GroupData.js").GroupData} GroupData
 */

export default function BusinessBreakdown({ setFetchError }) {
  /** @type {[GroupCount[], React.Dispatch<React.SetActionState<GroupCount[]>>]} */
  const [groupCounts, setGroupCounts] = useState([]);
  /** @type {[BusinessSizeCount[], React.Dispatch<React.SetActionState<BusinessSizeCount[]>>]} */
  const [businessSizeCounts, setBusinessSizeCounts] = useState([]);
  /** @type {[{contractCount: number, contractHolderCount: number}?, React.Dispatch<React.SetActionState<{contractCount: number, contractHolderCount: number}>>]} */
  const [contractCounts, setContractCounts] = useState({});

  useEffect(() => {
    getGroupCounts()
      .then((groupCountData) => {
        setContractCounts(getContractCounts(groupCountData));
        setGroupCounts(groupCountData);
      })
      .catch((error) => {
        setFetchError(error);
      });
  }, []);

  useEffect(() => {
    getBusinessSizeCounts()
      .then((businessSizeCountsData) => {
        setBusinessSizeCounts(businessSizeCountsData);
      })
      .catch((error) => {
        setFetchError(error);
      });
  }, []);

  if (businessSizeCounts.length > 0 && groupCounts.length > 0) {
    return (
      <div className="container-fluid">
        <Header contractHolderCount={contractCounts.contractHolderCount} contractCount={contractCounts.contractCount} />
        <ContractSummary groupCounts={groupCounts} />
        <BusinessSizeBreakdown businessSizeCounts={businessSizeCounts} />
      </div>
    );
  } else {
    return <div className="container-fluid">Loading Small Business Breakdown.</div>;
  }
}
